export enum RECORDING_LAYOUT_TYPE {
  FILL = 'FILL',
  FIT = 'FIT'
}

export enum SpeakerLayout {
  FILL = 'FILL',
  TILES = 'TILES'
}

export enum ScreenShareLayout {
  SHARED_FILL = 'SHARED_FILL',
  FILM_STRIP = 'FILM_STRIP',
  PIP = 'PIP',
  ONLY_SCREEN = 'ONLY_SCREEN'
}

export type LayoutOption = {
  label: string;
  value: string;
  type: string;
  component: any;
};

export enum PipShape {
  CIRCULAR = 'CIRCULAR',
  RECTANGULAR = 'RECTANGULAR'
}

export enum PipPosition {
  LEFT_TOP = 'LEFT_TOP',
  LEFT_BOTTOM = 'LEFT_BOTTOM',
  RIGHT_TOP = 'RIGHT_TOP',
  RIGHT_BOTTOM = 'RIGHT_BOTTOM',
  TOP_MIDDLE = 'TOP_MIDDLE',
  BOTTOM_MIDDLE = 'BOTTOM_MIDDLE',
  LEFT_MIDDLE = 'LEFT_MIDDLE',
  RIGHT_MIDDLE = 'RIGHT_MIDDLE'
}

export enum SpeakerPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export const NewLayoutNamesMap: Record<string, string> = {
  [ScreenShareLayout.SHARED_FILL]: '@@translate@@ Shared Fill',
  [ScreenShareLayout.FILM_STRIP]: '@@translate@@ Film Strip',
  [ScreenShareLayout.PIP]: '@@translate@@ Picture-in-Picture',
  [ScreenShareLayout.ONLY_SCREEN]: '@@translate@@ Only Screen Share',
  [SpeakerLayout.FILL]: '@@translate@@ Fill',
  [SpeakerLayout.TILES]: '@@translate@@ Fit'
};

export interface LayoutSettings {
  speakerLayout: SpeakerLayout;
  screenShareLayout: ScreenShareLayout;
  highlightActiveSpeaker: boolean;
  showBorders: boolean;
  roundedCorners: boolean;
  pipShape: PipShape;
  pipPosition: PipPosition;
  speakerPosition: SpeakerPosition;
  showActiveSpeakerOnly: boolean;
}

export const DEFAULT_LAYOUT_SETTINGS: LayoutSettings = {
  speakerLayout: SpeakerLayout.FILL,
  screenShareLayout: ScreenShareLayout.FILM_STRIP,
  highlightActiveSpeaker: false,
  showBorders: false,
  roundedCorners: false,
  pipShape: PipShape.CIRCULAR,
  pipPosition: PipPosition.RIGHT_BOTTOM,
  speakerPosition: SpeakerPosition.RIGHT,
  showActiveSpeakerOnly: false
};
